import React from 'react'
import { connect } from 'react-redux'
import toLower from 'lodash/toLower'
// import ReactJson from 'react-json-view'

import AttractionActions from '../../Redux/AttractionRedux'
import FilesActions from '../../Redux/FilesRedux'

class PlaceDetail extends React.Component {
  constructor (props) {
    super (props)
    this.state = {
      tab: null,
      edit: false,
      form: {
        language_code: toLower(props.setting.language_code),
        highlights: '',
        additional_info: '',
        description: ''
      },
      files: {},
      showModal: null,
      selected: {
        item: {},
        dimension: null,
        banner: null
      },
    }
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      form: {
        ...this.state.form,
        description: nextProps.attraction.detail.description
      }
    })
  }

  componentDidMount = () => {
    const { getPlaceDetail, detailId, reset} = this.props
    let data = {
      id: detailId
    }
    getPlaceDetail(data)
    reset()
  }

  render () {
    const { detail, fetching, err, processing } = this.props.attraction
    // const { files } = this.state

    const ImageTab = () => {
      return (
        <div>
          <div className="mb-3" style={{ borderBottom: '1px solid #ddd' }}>
            <div className="table-responsive">
              <table className="table table-hover table-bordered">
                <thead>
                  <tr>
                    <th>Caption</th>
                    <th>Dimension</th>
                    <th>Image</th>
                  </tr>
                </thead>
                <tbody>
                  {detail.local_photo && Object.keys(detail.local_photo.paths).map((dimension, key) => (
                    <tr key={key}>
                      {key === 0 &&
                        <td rowSpan={Object.keys(detail.local_photo.paths).length}>{detail.local_photo.caption || '-'}</td>
                      }
                      <td>
                        {dimension}
                      </td>
                      <td>
                        <img src={detail.local_photo.paths[dimension]} alt="" height="175px" className="img img-responsive"/>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )
    }

    return (
      <div className="section" style={{ width: '75vw' }}>
        <div className="title-block">
          <h4 className="title mr-auto">
            Landmark Detail
            {(fetching || processing) && <div className="badge badge-info ml-2">{fetching ? 'Loading' : 'Processing'} ...</div>}
          </h4>
        </div>
        {err && <div className="alert alert-danger">{err}</div>}

        {detail &&
          <div className="section">
            <div className="mb-4">
              <h4 className="title">{ detail.title || '-' }</h4>
              <p className="title-description">
                {/* <span className="badge badge-secondary">ID</span>{" "}
                { detail.short_id } */}
              </p>
            </div>
            <div>
              {/* VIEW */}
              {/* <ReactJson src={detail} /> */}
              <section>
                <header className="title">
                  <h3>Images</h3>
                </header>
                <ImageTab />
              </section>
              <section>
                <div className="form-group row">
                  <div className="col-xs-12 col-sm-2">
                    <label className="control-label">Address</label>
                  </div>
                  <div className="col-xs-12 col-sm-10">
                    {detail.address || '-'}
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-xs-12 col-sm-2">
                    <label className="control-label">Admission</label>
                  </div>
                  <div className="col-xs-12 col-sm-10">
                    {detail.admission || '-'}
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-xs-12 col-sm-2">
                    <label className="control-label">Email</label>
                  </div>
                  <div className="col-xs-12 col-sm-10">
                    {detail.email || '-'}
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-xs-12 col-sm-2">
                    <label className="control-label">Phone</label>
                  </div>
                  <div className="col-xs-12 col-sm-10">
                    {detail.phone || '-'}
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-xs-12 col-sm-2">
                    <label className="control-label">Description</label>
                  </div>
                  <div className="col-xs-12 col-sm-10">
                    {detail.description || '-'}
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-xs-12 col-sm-2">
                    <label className="control-label">Geolocation</label>
                  </div>
                  <div className="col-xs-12 col-sm-10">
                    Lat: <em>{detail.latitude}</em> <br/> Lon: <em>{detail.longitude}</em>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-xs-12 col-sm-2">
                    <label className="control-label">Opening Hours</label>
                  </div>
                  <div className="col-xs-12 col-sm-10">
                    {detail.opening_hours || '-'}
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-xs-12 col-sm-2">
                    <label className="control-label">Duration</label>
                  </div>
                  <div className="col-xs-12 col-sm-10">
                    {detail.duration || '-'}
                  </div>
                </div>
              </section>
              
            </div>
          </div>
        }
        <div className="form-group d-flex justify-content-end">
          <button className="btn btn-lg btn-secondary" onClick={() => this.props.closeModal()}>Close</button>
        </div>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  attraction: state.attraction,
  files: state.files,
})

const dispatchToProps = (dispatch) => ({
  getPlaceDetail: (data) => dispatch(AttractionActions.placeDetailRequest(data)),
  updateAttractionDetail: (data) => dispatch(AttractionActions.attractionUpdateRequest(data)),
  clearCache: () => dispatch(AttractionActions.attractionClearCacheRequest()),
  upload: (data) => dispatch(FilesActions.filesUploadRequest(data)),
  reset: () => dispatch(FilesActions.filesUploadReset())
})

export default connect(stateToProps, dispatchToProps)(PlaceDetail)



// WEBPACK FOOTER //
// ./src/Containers/Attraction/PlaceDetail.js